import React, {useEffect, useState} from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getReview, deleteReview } from '../api/reviewsApi';
import StarRating from '../components/StarRating';

export default function ReviewDetail(){
  const { id } = useParams();
  const [review, setReview] = useState(null);
  const nav = useNavigate();

  useEffect(()=> {
    getReview(id).then(setReview);
  }, [id]);

  if (!review) return <div>Loading...</div>;

  async function handleDelete(){
    if (!window.confirm('Delete this review?')) return;
    await deleteReview(id);
    nav('/react-projects/gamerfrog/reviews');
  }

  return (
    <article>
      <div className="card">
        <div style={{display:'flex', gap:12, alignItems:'center'}}>
          <div style={{flex:1}}>
            <h2 style={{marginTop:0}}>{review.title}</h2>
            <div className="meta">{review.platform} • {review.genre} • <time dateTime={review.date}>{review.date}</time> • by {review.author}</div>
          </div>
          <div style={{textAlign:'right'}}>
            <StarRating value={review.rating} size={20} />
          </div>
        </div>

        <p style={{marginTop:12}}>{review.summary}</p>

        <section style={{marginTop:14}}>
          <h3>Full review</h3>
          <p style={{lineHeight:1.6}}>{review.body}</p>
        </section>

        <div style={{display:'flex', gap:8, marginTop:14}}>
          <button className="btn" onClick={() => nav('/react-projects/gamerfrog/reviews')}>Back</button>
          <button className="btn ghost" onClick={handleDelete}>Delete</button>
        </div>
      </div>
    </article>
  );
}
